import { useField, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";

import {
  TextField,
  Button,
  Badge,
  useTheme,
  FormControl,
  MenuItem,
  Select,
  Typography,
  InputLabel,
  TextareaAutosize,
} from "@material-ui/core";
import DatePicker from "react-multi-date-picker";
import { Search, WatchLaterOutlined } from "@material-ui/icons";
import InputAdornment from "@material-ui/core/InputAdornment";
import { useLocation } from "react-router";
import { valid_Persian_email } from "../validation/ValidationFunctions";
import Store from "../redux/Store";
import {
  pageChange,
  searchBarChanged,
  allowToSearch,
} from "../redux/General/clientSideSearchActionCreators";
import { useStyles } from "../styles/mainStyles";
import { KeyboardTimePicker } from "@material-ui/pickers";

const TextFieldWrapper = ({ name, ...otherProps }) => {
  const [field, mata, form] = useField(name);
  const { setValue } = form;
  const config = {
    ...field,
    ...otherProps,
    fullWidth: true,
    variant: "outlined",
    size: "small",
  };

  if (mata && mata.error && mata.touched) {
    config.error = true;
    config.helperText = mata.error;
  }

  return (
    <TextField
      {...config}
      onKeyPress={(e) => {
        valid_Persian_email(e, field);
        e.stopPropagation();
      }}
      onChange={(e) => {
        setValue(e.target.value);
        e.stopPropagation();
      }}
    />
  );
};

export default TextFieldWrapper;

export const DatePickerTextFiled = ({
  changeHandler,
  action,
  defaultValue,
}) => {
  const [data, setDate] = React.useState("");
  const location = useLocation();
  const style = useStyles();
  let inputRef = React.useRef();
  useEffect(() => {
    setDate("");
  }, [location.pathname]);

  return (
    <DatePicker
      inputClass={style.datePicker}
      onFocusedDateChange={(e) => {
        const date = new Date(e.toDate()).toJSON();
        setDate(date);

        Store.dispatch(pageChange(0));
        changeHandler(date, action);
      }}
      value={data}
      ref={inputRef}
      onOpen={() => (inputRef.current.onkeypress = (e) => e.preventDefault())}
      type="input-icon"
      locale="fa"
      calendar="persian"
      animation={true}
      calendarPosition="auto-right"
      style={{ borderRadius: 4, boxShadow: "0 3px 6px rgba(0,0,0,0.16)" }}
    >
      <Button
        color="secondary"
        variant="contained"
        onClick={(e) => {
          e.stopPropagation();
          changeHandler(defaultValue, action);
          setDate("");
        }}
      >
        حدف تاریخ
      </Button>
    </DatePicker>
  );
};

export const SearchTextField = ({ is_server_side }) => {
  const [is_mounted, set_is_mounted] = React.useState(false);

  const [query, setQuery] = useState("");

  React.useEffect(() => {
    const timeOutId = setTimeout(() => { 
      Store.dispatch(searchBarChanged(query));

      if (is_server_side) {
        // this is to make sure only one request will triggered to server
        Store.dispatch(allowToSearch(false));
        // Store.dispatch(searchBarChanged(query));
        Store.dispatch(pageChange(0));
        Store.dispatch(allowToSearch(true));
      } else {
        Store.dispatch(searchBarChanged(query));
        set_is_mounted(true);
        if (is_mounted) {
          Store.dispatch(allowToSearch(true));
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps

      // Store.dispatch(pageChange(0))
    }, 500);
    return () => {
      clearTimeout(timeOutId);
    };
    // eslint-disable-next-line
  }, [query]);
  React.useEffect(() => {
    set_is_mounted(true);
  }, []);
  const theme = useTheme();
  return (
    <TextField
      variant="outlined"
      size="small"
      fullWidth
      color="primary"
      InputProps={{
        endAdornment: (
          <InputAdornment position="start">
            <Badge
              style={{
                position: "absolute",
                left: "0.1%",
                backgroundColor: theme.palette.primary.main,
                borderRadius: "5px",
                height: "100%",
                width: "2.5em",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Search style={{ color: "white" }} fontSize="large" />
            </Badge>
          </InputAdornment>
        ),
      }}
      type="search"
      name="customer-search"
      className="searchBox"
      placeholder="جستجو..."
      defaultValue=""
      onChange={(e) => setQuery(e.target.value)}
    />
  );
};

export const Selectwrapper = ({ name, label, options, ...otherProps }) => {
  const [field, mata] = useField(name);

  const config = {
    ...field,
    ...otherProps,
  };

  if (mata && mata.error && mata.touched) {
    config.error = true;
    config.helpertext = mata.error;
  }

  return (
    <FormControl fullWidth size="small" variant="outlined">
      <InputLabel>{label}</InputLabel>
      <Select {...config} label={label} defaultValue="">
        {options !== undefined ? (
          options.map((item, index) => {
            return (
              <MenuItem key={index} value={item.value}>
                {item.title}
              </MenuItem>
            );
          })
        ) : (
          <MenuItem value={field.value}>{field.value}</MenuItem>
        )}
      </Select>
      {mata && mata.error && mata.touched ? (
        <Typography variant="button" color="secondary">
          {mata.error}
        </Typography>
      ) : null}
    </FormControl>
  );
};

export const TextFieldArea = ({ name, ...otherProps }) => {
  const [field, mata] = useField(name);

  const config = {
    ...field,
    ...otherProps,
  };

  if (mata && mata.error && mata.touched) {
    config.error = true;
    config.helperText = mata.error;
  }

  return <TextareaAutosize style={{ width: "100%" }} minRows={4} {...config} />;
};

export const MuiTimePicker = ({ ...otherProps }) => {
  const [field] = useField(otherProps);
  const { setFieldValue } = useFormikContext();

  return (
    <KeyboardTimePicker
      cancelLabel="انصراف"
      okLabel="ذخیره"
      onKeyPress={(e) => e.preventDefault()}
      color="primary"
      keyboardIcon={<WatchLaterOutlined color="primary" />}
      fullWidth
      ampm={false}
      name={field.name}
      format="hh:mm"
      value={field.value}
      onChange={(value) => {
        if (value !== null) {
          setFieldValue(field.name, value);
        }
      }}
      inputProps={{
        style: {
          fontSize: 14,
        },
      }}
      variant="dialog"
      inputVariant="outlined"
      size="small"
      {...otherProps}
    />
  );
};
